<!--
  - Copyright (c) 2018 BarD Software s.r.o
  -->

<template>
    <div class="project-lock-modal modal fade" @keydown="applyShortcut">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4>Lock Project</h4>
                </div>
                <div class="modal-body">
                    <p class="text-muted">Only you can update project when you hold the lock. The lock will expire after:</p>
                    <div class="list-group" id="validity-choice" role="tablist">
                        <a class="list-group-item list-group-item-action active" data-toggle="list" href="#" role="tab">
                            <i class="far fa-dot-circle fa-lg icon-selected"></i>
                            <i class="far fa-circle fa-lg icon-unselected"></i>
                            <span>1 hour</span>
                            <input type="hidden" value="1">
                        </a>
                        <a class="list-group-item list-group-item-action" data-toggle="list" href="#" role="tab">
                            <i class="far fa-dot-circle fa-lg icon-selected"></i>
                            <i class="far fa-circle fa-lg icon-unselected"></i>
                            <span>2 hours</span>
                            <input type="hidden" value="2">
                        </a>

                        <a class="list-group-item list-group-item-action" data-toggle="list" href="#" role="tab">
                            <i class="far fa-dot-circle fa-lg icon-selected"></i>
                            <i class="far fa-circle fa-lg icon-unselected"></i>
                            <span>24 hours</span>
                            <input type="hidden" value="24">
                        </a>
                        <a class="list-group-item list-group-item-action" data-toggle="list" href="#" role="tab">
                            <i class="far fa-dot-circle fa-lg icon-selected"></i>
                            <i class="far fa-circle fa-lg icon-unselected"></i>
                            <span>Custom period&nbsp;
                                <input class="hours-input" type="number" min="1">
                                &nbsp;hours</span>
                        </a>
                    </div>
                </div>
                <div class="modal-footer">
                    <BtnSubmit title="Lock" spinner ref="submitButton" :submit-handler="lock"></BtnSubmit>
                </div>

            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Prop, Component, Vue} from 'vue-facing-decorator';
import {updateDependencies} from '../Dashboard';
import {loadTeam, ProjectDto, TeamDto} from '../Teams';
import {getOrRequireValue, handleXhrError, ShortcutHandler} from '../utils/Ui';
import {ProjectLock} from '../ProjectRoutes';
import BtnSubmit from './BtnSubmit.vue';
import {Deferred} from "jquery";

import $ from 'jquery';

@Component({
  components: {BtnSubmit},
})
export default class ProjectLockModal extends Vue {

  @Prop()
  public team: TeamDto;

  @Prop()
  public project: ProjectDto;
  private shortcutHandler = new ShortcutHandler();

  public constructor() {
    super();
    this.shortcutHandler.register('Enter', () => this.lock());
  }

  public mounted() {
    $(this.$el).on('shown.bs.modal', () => $('#validity-choice a:first').focus());
  }

  public lock() {
    const input = $(this.$el).find('.list-group-item.active input') as JQuery<HTMLElement>;
    const valueInHours = getOrRequireValue(input);

    if (!valueInHours) {
      return Deferred().reject();
    }

    const valueInSeconds = 3600 * valueInHours;
    if (valueInSeconds && valueInSeconds > 0) {
      $(this.$el).modal('hide');
      return ProjectLock.invoke({
        projectRefid: this.project!.refid,
        expirationPeriodSeconds: valueInSeconds,
      })
          .then(() => loadTeam(this.team.refid))
          .then((teamDto: TeamDto) => {
            updateDependencies(teamDto);
            teamDto.projects.forEach((it: ProjectDto) => {
              if (it.refid === this.project.refid) {
                this.project.lock = it.lock;
              }
            })
          })
          .fail((jqXhr) => handleXhrError(jqXhr, 'can\'t lock project'));
    } else {
      return Deferred().reject();
    }
  }

  public applyShortcut(e: KeyboardEvent) {
    this.shortcutHandler.handle(e);
  }
}
</script>
